module.exports = __webpack_public_path__ + "static/media/creating_room.81a671d6.webm";